import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { AccountReactivationProps } from './props'
import {
  Container,
  ButtonsContainer,
  MessageContainer,
  Title,
  Text,
  Button,
} from './styles'

export const AccountReactivation: FunctionComponent<AccountReactivationProps> = ({
  onCloseSucccess,
}) => {
  const { t } = useTranslation()

  return (
    <Container>
      <MessageContainer>
        <Title>{t('reviewsPage.reactivationModalTitle')}</Title>
        <Text>{t('reviewsPage.reactivationModalText1')}</Text>
        <Text>{t('reviewsPage.reactivationModalText2')}</Text>
      </MessageContainer>
      <ButtonsContainer>
        <Button onClick={onCloseSucccess}>
          {t('reviewsPage.reactivationModalButton')}
        </Button>
      </ButtonsContainer>
    </Container>
  )
}
